import $ from 'jquery';
import { handleAiEdit } from './index';
import { exceedsDragThreshold } from './exceedsDragThreshold';

// Oltre questa distanza (px) tra pressione e rilascio del puntatore, il gesto
// è un trascinamento accidentale e non deve applicare la feature IA.
const AI_EDIT_DRAG_THRESHOLD_PX = 8;

export default function initAiEditListeners() {
  // Remove existing listeners to prevent duplicates
  $('body').off('mousedown', '[data-ai-edit]');
  $('body').off('click', '[data-ai-edit]');

  // Track where the pointer was pressed so we can tell a click from a drag.
  let pointerDownPos = null;

  $('body').on('mousedown', '[data-ai-edit]', (e) => {
    pointerDownPos = { x: e.pageX, y: e.pageY };
  });

  // Attach namespaced event listener
  $('body').on('click', '[data-ai-edit]', function (e) {
    e.preventDefault();

    // Anti-drag guard: a click that ends more than the threshold away from
    // where it started is an accidental drag, not an intentional click — do
    // not apply the AI feature to the selected photo.
    const draggedAway = exceedsDragThreshold(
      pointerDownPos,
      { x: e.pageX, y: e.pageY },
      AI_EDIT_DRAG_THRESHOLD_PX
    );
    pointerDownPos = null;
    if (draggedAway) {
      return;
    }

    const prompt = $(this).data('ai-edit');
    handleAiEdit(prompt);
  });
}
